import { memo, useCallback, useEffect, useMemo, useRef } from 'react';
import { Pressable, StyleSheet, Text, TextInput, View } from 'react-native';
import AppColors from '../../common/colors';
import LoginInput from '../login_input';
import localization from '../../common/localization';
import { useStateRef } from '../../common/hooks';
import { VoidCb } from '../../types/others';
import { commonStyles } from '../../common/styles';

type Props = {
  onSubmit?: (pass?: string) => void;
  onCancel?: VoidCb;
};

const ParentDialogMobile = memo<Props>(({ onSubmit, onCancel }) => {
  const [pass, passRef, setPass] = useStateRef('');

  const inputRef = useRef<TextInput>(null);

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  const sumbit = useCallback(() => onSubmit?.(passRef.current), [onSubmit]);

  return (
    <View style={styles.container}>
      <Pressable onPress={onCancel} style={commonStyles.fill} />
      <View style={styles.dialogContainer}>
        <Text style={styles.title}>{localization.general.enterParentPass}</Text>
        <View style={styles.inputContainer}>
          <LoginInput
            id='parent_pass'
            value={pass}
            onChanged={setPass}
            placeholder={localization.account.password}
            onSubmit={sumbit}
            submitType='next'
            backgroundColor={'#303437'}
            secured
            inputRef={inputRef}
          />
        </View>
        <DialogButton text={localization.general.ok} primary onPress={sumbit} />
        <DialogButton text={localization.general.cancel} onPress={onCancel} />
      </View>
    </View>
  );
});
ParentDialogMobile.displayName = 'ParentDialogMobile';

type ButtonProps = {
  text: string;
  primary?: boolean;
  onPress?: VoidCb;
};

const DialogButton = memo<ButtonProps>(({ text, primary, onPress }) => {
  const [containerStyle, textStyle] = useMemo(
    () =>
      primary
        ? [styles.actionContainer, styles.actionText]
        : [styles.actionContainerSecondary, styles.actionTextSecondary],
    [primary],
  );

  return (
    <Pressable onPress={onPress} style={containerStyle}>
      <Text style={textStyle}>{text}</Text>
    </Pressable>
  );
});

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: AppColors.semiBlack,
    justifyContent: 'center',
  },
  dialogContainer: {
    backgroundColor: AppColors.containerGray,
    marginHorizontal: 40,
    paddingTop: 24,
    paddingBottom: 12,
    paddingHorizontal: 24,
    borderRadius: 16,
  },
  title: {
    ...commonStyles.text,
    color: 'white',
    fontSize: 24,
    fontWeight: '700',
    marginBottom: 6,
    textAlign: 'center',
  },
  inputContainer: {
    marginBottom: 8,
  },
  actionContainer: {
    backgroundColor: AppColors.mainBlue,
    alignItems: 'center',
    marginBottom: 12,
    paddingVertical: 16,
    borderRadius: 8,
  },
  actionContainerSecondary: {
    alignItems: 'center',
    marginBottom: 12,
    paddingVertical: 16,
  },
  actionText: {
    ...commonStyles.text,
    color: 'white',
    fontSize: 16,
  },
  actionTextSecondary: {
    ...commonStyles.text,
    color: '#6C7072',
    fontSize: 16,
  },
});

export default ParentDialogMobile;
